/*
 * Veil Points in the cart (snippets/rv-points-cart.liquid). One reward per order:
 *   200 points = $10 off orders $60+;  400 points = $20 off orders $120+ (so a $120 order still gets free shipping).
 * Signed-in shoppers see the rewards that fit their cart. A reward code they already have (unused) is offered first,
 * so points are never spent twice. Redeeming makes a single-use code (Worker /apps/rv/points/redeem) and applies it
 * through Shopify's /discount/<code> link, which lands on the cart page.
 */
(function () {
  var TIERS = [{ value: 20, cost: 400, min: 120 }, { value: 10, cost: 200, min: 60 }];   // best first
  var summary = null, summaryAt = 0;

  function getSummary() {
    if (!summary || Date.now() - summaryAt > 60000) {
      summaryAt = Date.now();
      summary = fetch('/apps/rv/points', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return {}; });
    }
    return summary;
  }
  function useCode(code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart'; }
  function money(n) { return '$' + n; }

  function fill(box) {
    box.setAttribute('data-ready', '');
    if (box.getAttribute('data-applied') === 'true') {
      box.innerHTML = '<p class="rv-pts-cart__done">Veil Points reward applied</p>';
      box.hidden = false;
      return;
    }
    var subtotal = (parseInt(box.getAttribute('data-subtotal'), 10) || 0) / 100;
    getSummary().then(function (s) {
      if (!s || !s.signedIn) return;
      var points = s.points || 0;
      var codes = (s.codes || []).filter(function (c) { return c && c.code; });
      var fitCodes = codes.filter(function (c) { return subtotal >= c.min; }).sort(function (a, b) { return b.value - a.value; });
      var fitTiers = TIERS.filter(function (t) { return points >= t.cost && subtotal >= t.min; });
      if (!fitCodes.length && !fitTiers.length) {
        // Nothing fits yet: say how close they are, if they have something to use.
        if (points >= 200 || codes.length) {
          box.innerHTML = '<p class="rv-pts-cart__text">You have <strong>' + points + ' Veil Points</strong>. Spend $60 or more to use $10 off.</p>';
          box.hidden = false;
        }
        return;
      }
      var html = '<p class="rv-pts-cart__text">You have <strong>' + points + ' Veil Points</strong>.</p>';
      if (fitCodes.length) {
        html += '<button type="button" class="rv-pts-cart__btn" data-code="' + fitCodes[0].code.replace(/[^A-Z0-9-]/g, '') + '">Use my ' + money(fitCodes[0].value) + ' reward</button>';
      } else {
        fitTiers.forEach(function (t) {
          html += '<button type="button" class="rv-pts-cart__btn" data-value="' + t.value + '">Use ' + t.cost + ' points for ' + money(t.value) + ' off</button>';
        });
        if (fitTiers.length === 1 && fitTiers[0].value === 10 && points >= 400) html += '<p class="rv-pts-cart__hint">Spend $120 or more to use $20 off.</p>';
      }
      box.innerHTML = html + '<p class="rv-pts-cart__msg" role="status"></p>';
      box.hidden = false;
      var msg = box.querySelector('.rv-pts-cart__msg');
      box.querySelectorAll('.rv-pts-cart__btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.getAttribute('data-code')) { useCode(btn.getAttribute('data-code')); return; }
          box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          msg.textContent = 'Applying…';
          fetch('/apps/rv/points/redeem', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ value: Number(btn.getAttribute('data-value')) }) })
            .then(function (r) { return r.json(); })
            .then(function (r) {
              if (r.ok && r.code) { summary = null; useCode(r.code); return; }
              box.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
              msg.textContent = r.reason === 'slow_down' ? 'One moment, then try again.' : 'Something went wrong. Your points are safe. Please try again.';
            })
            .catch(function () { box.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); msg.textContent = 'Something went wrong. Please try again.'; });
        });
      });
    });
  }

  function scan() { document.querySelectorAll('[data-rv-pts-cart]:not([data-ready])').forEach(fill); }
  if (document.documentElement.getAttribute('data-rv-signed-in') !== 'true') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  // The side cart re-draws itself after every change.
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
